Auth = require 'db/auth'
EntityDisplay = require 'lib/entity-display'
NotificationView = require './notification-view'
React = require 'react'
recup = require 'recup'
t = require('views/internal/teacup-with-helpers')('')
TFM = require 'lib/markdown/tfm'
_ = require 'underscore'
SimpleTest = require 'lib/experiments/simple-test'

previousMemberID = 0
module.exports = class extends React.Component
  displayName: 'NotificationsList'

  constructor: (props) ->
    super(props)

    isShowCards = SimpleTest('cardNotifications').get('showCards') && @props.context == "header"
    @state = {
      now: new Date()
      isShowCards
      entityDisplay: new EntityDisplay(if isShowCards then 'notificationsGrouped' else 'notification')
    }

  componentDidMount: ->
    @interval = setInterval(@updateNow, 10000)

  componentWillUnmount: ->
    clearInterval(@interval)

  updateNow: =>
    @setState now: new Date()

  _generatePropsFromNotif: (notif) =>
    { now, isShowCards, entityDisplay } = @state

    notifProps = notif.getExpandedData()
    notifProps.type = notif.get('type')
    notifProps.iconKey = notif.get('display')?.translationKey

    notifProps.entities = entityDisplay.getEntities(notif.get 'display')
    for entity in notifProps.entities
      if entity.type == 'comment'
        entity.textHtml = TFM.comments.format(entity.text).output
      else if entity.type == 'relDate'
        entity.text = entityDisplay.relDateText(entity.date, now)

    if notifProps.type == 'cardDueSoon'
      notifProps.isDueDateNotification = true
    else if notifProps.type in [
      'declinedInvitationToBoard'
      'declinedInvitationToOrganization'
    ]
      notifProps.isDeclinedInvitationNotification = true

    if /Enterprise/.test(notifProps.type)
      notifProps.isEnterpriseAdmin = Auth.me().isEnterpriseAdminOf(notif.get('data').enterprise)

    notifProps.isDueSoon = notifProps.type == 'cardDueSoon '
    notifProps.isCommentLike = notif.isCommentLike()
    notifProps.isAddAttachment = notif.isAddAttachment()
    notifProps.idMemberCreator = notif.get('idMemberCreator')

    notifProps.markRead = notif.markRead.bind(notif)
    notifProps.toggleRead = notif.toggleRead.bind(notif)
    notifProps.navigateToView = notif.navigateToView.bind(notif)

    notifProps.context = @props.context
    member = notif.getMember()

    if (!isShowCards)
      notifProps.member = member
    else if (member? && previousMemberID != member.id)
      notifProps.member = member
      previousMemberID = member.id


    notifProps

  render: ->
    { notifications, context } = @props

    if @state.isShowCards
      notifications =
        _.map(notifications.groupings, (notificationGrouping, key) =>
          props = _.extend({ context }, notificationGrouping)

          previousMemberID = 0

          props.notifications = _.map(
            notificationGrouping.notifications,
            @_generatePropsFromNotif
          )

          props.markRead = ->
            _.forEach(props.notifications, (notif) -> notif.markRead())

          props.toggleRead = ->
            _.forEach(props.notifications, (notif) -> notif.toggleRead())

          props.key = key
          React.createElement NotificationView, props
        )
    else
      notifications =
        _.map(notifications, (notification) =>
          props = @_generatePropsFromNotif(notification)

          props.key = notification.id
          React.createElement NotificationView, props
        )

    React.createElement 'div', null, notifications



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-list.coffee